import { render, staticRenderFns } from "./SpecificationSectionGroupCreate.vue?vue&type=template&id=45b26e9c"
import script from "./SpecificationSectionGroupCreate.vue?vue&type=script&lang=js"
export * from "./SpecificationSectionGroupCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports